module.exports = __webpack_public_path__ + "static/img/dstx.ea46209.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dstx.png
// module id = MlkR
// module chunks = 1